const css = require('../user-shared-data-form/user-shared-data-form.css');
const { Text } = require('account-ui');
const { inputText, blurText } = require('../../../../signals/form');
const SCHEMES = require('../../../../helpers/scheme');

class UserForm {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, this.$context.props, { css }));
    }
}

module.exports = function (formPath) {
    return {
        constructor: UserForm,
        children: [
            {
                name: 'text-org',
                component: Text,
                props: {
                    signals: { inputText, blurText }
                },
                watcher: {
                    value: formPath.concat(['form', 'organization'])
                }
            },
            {
                name: 'text-inn10',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight',
                    scheme: SCHEMES.inn10
                },
                watcher: {
                    value: formPath.concat(['form', 'inn10']),
                    error: formPath.concat(['error', 'inn10'])
                }
            },
            {
                name: 'text-bin',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight',
                    scheme: SCHEMES.bin
                },
                watcher: {
                    value: formPath.concat(['form', 'bin']),
                    error: formPath.concat(['error', 'bin'])
                }
            },
            {
                name: 'text-kpp',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight',
                    scheme: SCHEMES.kpp
                },
                watcher: {
                    value: formPath.concat(['form', 'kpp']),
                    error: formPath.concat(['error', 'kpp'])
                }
            },
            {
                name: 'text-legal-address',
                component: Text,
                props: {
                    signals: { inputText, blurText }
                },
                watcher: {
                    value: formPath.concat(['form', 'legalAddress'])
                }
            }
        ]
    };
};



// WEBPACK FOOTER //
// ./components/common/user/legal-entity-form/index.js